import { Action, Dispatch } from 'redux';

import { CATEGORIES_URL, RequestId } from 'appConstants';
import { ApiRequest } from 'services';
import { Category } from 'types';

/* Types */

export interface CategoriesAction extends Action {
  readonly categories?: Category[];
}

export interface Categories {
  readonly items: Category[];
}

export interface CategoriesResponse {
  readonly categories: Category[];
}

/* Initial State */

const initialState = {
  items: [],
} as Categories;

/* Actions */

enum Actions {
  CLEAR_CATEGORIES = 'CLEAR_CATEGORIES',
  SET_CATEGORIES = 'SET_CATEGORIES',
}

const clearCategories = (): CategoriesAction => ({
  type: Actions.CLEAR_CATEGORIES,
});

const setCategories = (categories: Category[]) => ({
  type: Actions.SET_CATEGORIES,
  categories,
});

/* Reducer */

const categoriesReducer = (state = initialState, action: CategoriesAction) => {
  switch (action.type) {
    case Actions.CLEAR_CATEGORIES:
      return {
        ...state,
        items: [],
      };
    case Actions.SET_CATEGORIES:
      return {
        ...state,
        items: action.categories,
      };
    default:
      return state;
  }
};

/* Thunk */

const getCategories = () => async (dispatch: Dispatch<CategoriesAction>) => {
  const onError = () => dispatch(clearCategories());

  const onSuccess = (response: CategoriesResponse) =>
    dispatch(setCategories(response.categories));

  return ApiRequest.get(CATEGORIES_URL, {
    dispatchId: RequestId.GET_CATEGORIES,
    onError,
    onSuccess,
  });
};

export { categoriesReducer, clearCategories, getCategories };
